var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.954,
    height: 15.954,
    viewBox: "0 0 15.954 15.954",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "postbox") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#768092;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.8,3.988H3.324V2.659h2.16a.5.5,0,0,0,.5-.5V.5a.5.5,0,0,0-.5-.5H2.659a.665.665,0,0,0-.665.665V4.27A3.326,3.326,0,0,0,0,7.312v4.653a.665.665,0,0,0,.665.665H5.983a.707.707,0,0,0,.083-.017.5.5,0,0,0,.083.017H7.977v2.659a.665.665,0,0,0,1.329,0V12.63h6.149a.5.5,0,0,0,.5-.5V7.146A3.161,3.161,0,0,0,12.8,3.988ZM5.318,11.3H1.329V7.312a1.994,1.994,0,0,1,3.988,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostbox);
export default __webpack_public_path__ + "static/media/postbox.a71f37e5de4f0791e800ed950fccd103.svg";
export { ForwardRef as ReactComponent };